module.exports = "<router-outlet></router-outlet>\n<!-- <app-custom-loader [showLoader] =\"showLoader\"> </app-custom-loader> -->"


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main